namespace Cfnc {
    /** Enum use to represent how rules are joined. */
    export enum JoinOperator {
        /** This is the default JoinOperator */
        None,
        And,
        Or,
    }
} 